import { useState, useEffect, useRef } from 'react';
import { Plus, Tag, Building2 } from 'lucide-react';

const MENU_ITEMS = [
  { id: 'lead',        label: 'Lead',       Icon: Tag,       disabled: false },
  { id: 'conta',       label: 'Conta',      Icon: Building2, disabled: false },
  { id: 'tarefa',      label: 'Tarefa',     Icon: null,      disabled: true, soon: true },
  { id: 'interacao',   label: 'Interação',  Icon: null,      disabled: true, soon: true },
];

export default function QuickAddFAB({ onNewLead, onNewConta }) {
  const [expanded, setExpanded] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!expanded) return;

    function handleKey(e) {
      if (e.key === 'Escape') setExpanded(false);
    }
    function handleClick(e) {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setExpanded(false);
      }
    }

    document.addEventListener('keydown', handleKey);
    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.removeEventListener('mousedown', handleClick);
    };
  }, [expanded]);

  function handleItemClick(item) {
    setExpanded(false);
    if (item.id === 'lead') onNewLead();
    if (item.id === 'conta') onNewConta();
  }

  return (
    <div
      ref={containerRef}
      className="fixed z-50 flex flex-col items-end gap-2 bottom-[max(1.5rem,env(safe-area-inset-bottom))] right-[max(1.5rem,env(safe-area-inset-right))]"
    >
      {expanded && (
        <div className="flex flex-col items-end gap-2 mb-1">
          {MENU_ITEMS.map((item, i) => (
            <div
              key={item.id}
              className="flex items-center gap-2"
              style={{
                animation: `fabItemIn 150ms ease ${i * 30}ms both`,
              }}
            >
              <span className={`text-xs px-2 py-0.5 rounded-full whitespace-nowrap select-none ${
                item.disabled
                  ? 'bg-white/5 text-white/25'
                  : 'bg-[#002233] text-white/80 shadow border border-white/10'
              }`}>
                {item.label}
                {item.soon && <span className="ml-1 text-white/30">(em breve)</span>}
              </span>
              <button
                type="button"
                disabled={item.disabled}
                onClick={() => handleItemClick(item)}
                className={`min-h-[44px] min-w-[44px] sm:min-h-0 sm:min-w-0 w-11 h-11 sm:w-9 sm:h-9 rounded-full flex items-center justify-center shadow-lg transition-transform active:scale-95 ${
                  item.disabled
                    ? 'bg-white/10 text-white/20 cursor-not-allowed'
                    : 'bg-[#002233] border border-[#00DBFF]/30 text-[#00DBFF] hover:bg-[#00DBFF]/10'
                }`}
                aria-label={item.label}
              >
                {item.Icon ? <item.Icon size={16} /> : <Plus size={16} />}
              </button>
            </div>
          ))}
        </div>
      )}

      <button
        type="button"
        onClick={() => setExpanded((v) => !v)}
        className={`w-14 h-14 sm:w-12 sm:h-12 rounded-full flex items-center justify-center shadow-xl transition-transform active:scale-95 bg-[#00DBFF] text-[#002233] hover:brightness-110 ${
          expanded ? 'rotate-45' : 'rotate-0'
        } transition-all duration-200`}
        aria-label="Adicionar"
        aria-expanded={expanded}
      >
        <Plus size={24} strokeWidth={2.5} />
      </button>

      <style>{`
        @keyframes fabItemIn {
          from { opacity: 0; transform: scale(0.8) translateY(8px); }
          to   { opacity: 1; transform: scale(1) translateY(0); }
        }
      `}</style>
    </div>
  );
}
